var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "wrapper",
      style: "margin-top: " + _vm.marginTop + "px",
      attrs: { id: "wrapper" }
    },
    [
      _c(
        "app-header",
        { ref: "header" },
        [
          _c(_vm.sidebar, {
            tag: "component",
            attrs: { slot: "menu" },
            slot: "menu"
          }),
          _vm.searchPage
            ? _c("jumbotron", {
                staticClass: "jumbotron",
                attrs: { slot: "jumbotron" },
                slot: "jumbotron"
              })
            : _vm._e()
        ],
        1
      ),
      _c("main", { staticClass: "container main" }, [
        _c(
          "div",
          [!_vm.user ? _c("splash", { staticClass: "mb-5" }) : _vm._e()],
          1
        ),
        _c("div", { staticClass: "row" }, [
          !_vm.notLoginIndex
            ? _c(
                "div",
                {
                  staticClass: "d-md-block",
                  class: {
                    "col-md-4 col-lg-3": !_vm.notLoginIndex
                  }
                },
                [
                  _c(
                    "transition",
                    { attrs: { name: "slide", mode: "out-in" } },
                    [_c(_vm.sidebar, { tag: "component" })],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "col-12",
              class: {
                "col-md-8 col-lg-9": !_vm.notLoginIndex
              }
            },
            [_c("div", [_c("nuxt")], 1)]
          )
        ])
      ]),
      _c("div", [_c("post-modal", { ref: "postModal" })], 1),
      _c("div", [_c("remove-modal", { ref: "removeModal" })], 1),
      _c("div", [_c("help-modal", { ref: "helpModal" })], 1)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-314f53c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-314f53c6","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./layouts/default.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-314f53c6","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./layouts/default.vue
// module chunks = 0